module.exports = __webpack_public_path__ + "media/images/shared/delivery/alfa-6bf050c709b80d8d76d5ffc55497048b.png";